import Masonry from 'masonry-layout';

class MasonryGrid {
  public msnry: Masonry;

  constructor(el: HTMLElement) {
    this.msnry = new Masonry(el, {
      // options
      itemSelector: '.col',
      horizontalOrder: true,
      percentPosition: true
    });
  }
}

export default MasonryGrid;
